import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap'

interface IProps {
    confirmButtonTitle?: string,
    confirmButtonVariant?: string,
    loading: boolean,
    disabled?: boolean,
    onSave: React.MouseEventHandler<HTMLElement>,
    icon?: IconProp
}

const ConfirmButton = ({ confirmButtonTitle, confirmButtonVariant, loading, disabled, onSave, icon }: IProps) => {

    const saveBtnRef = useRef<HTMLButtonElement>(null)

    useEffect(() => {

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter' && !loading && !disabled) {
                onSave(event as unknown as React.MouseEvent<HTMLElement>)
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [loading, disabled, onSave])

    return (
        <Button type='button' ref={saveBtnRef} variant={confirmButtonVariant} onClick={onSave} disabled={loading || disabled}>
            {icon &&
                <>
                    <FontAwesomeIcon icon={icon} />
                    {' '}
                </>
            }
            {confirmButtonTitle}
        </Button>
    )
}

export default ConfirmButton